import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const Ending = () => {
    const relativeDivRef = useRef(null);
    const [shadeHeight, setShadeHeight] = useState(0);

    useEffect(() => {
        if (relativeDivRef.current) {
            setShadeHeight(relativeDivRef.current.clientHeight);
        }
    }, []);

    return (
        <div className="">
             <div
                className="rounded-4"
                style={{
                    backgroundImage: `url(https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60,w_${window.innerWidth},h_${window.innerHeight}/https://img.freepik.com/free-vector/abstract-background-with-pink-purple-flowing-lines-design_1048-20364.jpg?t=st=1743033102~exp=1743036702~hmac=b10f2e0856ce6c240b75c65af8044f7a15f20335d40393ec94fa8ef830ab4dca&w=900)`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    overflow: "hidden", // Prevents horizontal scrolling
                    position: "relative", // Ensures absolute children stay within bounds
                }}
            >
                <div
                    style={{
                        zIndex: 20,
                        height: `${shadeHeight}px`,
                        background: "rgba(0, 0, 0, 0.5)", // Example shade color
                        position: "absolute",
                        left: 0,
                        right: 0, // Ensures it stays within parent width
                    }}
                    className="shade"
                ></div>
                
                <div style={{ zIndex: 30 }} className="position-relative" ref={relativeDivRef}>
                    <div className="container-fluid py-5">
                        <div className="px-md-5">
                            <div className="px-3">
                                <div className="row py-5">
                                    <div className="col-md-6 col-12">
                                        <h1 className="text-light">Get Started Today</h1>
                                        <h4 style={{ fontWeight: 300 }} className="text-light">
                                            Start staking VCT today and unlock unlimited earning potential
                                        </h4>
                                        <div className=" d-flex">
                                            <Link to="/sign-up"  onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} className="btn btn-light mx-2">Join VCT</Link>
                                            <Link to="/education" onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })}  className="btn btn-light mx-2">Learn More</Link>
                                        </div>
                                    </div>
                                    {/* <div className="d-flex align-items-center justify-content-md-end col-md-6 col-12 px-md-5">
                                        <div className="px-md-5">
                                            <button className="btn btn-light">Join Our Community</button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ending;
